import { render } from "./file-preview.html?vue&type=template&id=c26a583a&scoped=true&ts=true&external"
import script from "./file-preview.ts?vue&type=script&lang=ts&external"
export * from "./file-preview.ts?vue&type=script&lang=ts&external"

import "./file-preview.scss?vue&type=style&index=0&id=c26a583a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c26a583a"]])

export default __exports__